import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RemitosService {
  constructor(private http: HttpClient) {}

  // ✅ Opción A: endpoint tipo /remitos?code=...&since=...&from=...
  get(code: string, since: string, from: string): Observable<any> {
    const params = new HttpParams()
      .set('cliente', code)
      .set('fechaDesde', since)
      .set('fechaHasta', from);

    return this.http.get(environment.remitos, { params });
  }

  // ✅ Opción B (si tu endpoint es /remitos/{code}/{since}/{from})
  // get(code: string, since: string, from: string): Observable<any> {
  //   return this.http.get(`${environment.remitos}/${code}/${since}/${from}`);
  // }
}
